import EventMaxWidthV4 from './EventMaxWidthV4';
import TopModuleBackgroundV4 from './TopModuleBackgroundV4';
import Badge from '../../common/component/Badge';
import SingleText from '../../common/component/SingleText';
import {REGION} from '../../common/constant';
import {EVENT_TOP_GRADIENT_BOX_CN, EVENT_TOP_HEIGHT_CN} from '../common';
import {ITopModuleV4} from '../type';

interface IProps {
  data: ITopModuleV4;
}

export default function TopModuleV4({data}: IProps) {
  const {remainText, titles, copyright, ...restBackProps} = data;
  const isKorea = REGION === 'kor';

  return (
    <div
      className={cn('relative overflow-hidden', EVENT_TOP_HEIGHT_CN)}
      data-module-type="top"
    >
      <TopModuleBackgroundV4 {...restBackProps} />
      <div className={cn(EVENT_TOP_GRADIENT_BOX_CN, 'flex pb-18')}>
        <EventMaxWidthV4 className="w-full flex flex-col justify-end items-center">
          <div>
            {titles.map((text, index) => (
              <SingleText
                key={index}
                className={cn(
                  's22-extrabold-white tracking-[-0.4px]',
                  'max-w-[284px] text-center',
                  isKorea ? 'leading-30' : 'leading-34'
                )}
              >
                {text}
              </SingleText>
            ))}
          </div>
          <Badge
            variant="s10_black_white"
            isBig
            label={remainText}
            className="mt-6"
          />
          {!!copyright && (
            <SingleText
              className={cn(
                's12-regular-white leading-15 tracking-[-0.4px]',
                'opacity-50 mt-6 text-center max-w-[284px]'
              )}
            >
              {copyright}
            </SingleText>
          )}
        </EventMaxWidthV4>
      </div>
    </div>
  );
}
